// Types
import { GoalStatusType } from 'Shared/constants/types';

// Constants
import Colors from 'Wpds/colors/ColorConstants';

export const getGoalStatusColor = ({ status }: { status: GoalStatusType }) => {
  switch (status) {
    case 'no_status':
      return Colors.blue[500];
    case 'achieved':
      return Colors.purple[500];
    case 'at_risk':
      return Colors.yellow[500];
    case 'missed':
      return Colors.red[500];
    case 'on_track':
      return Colors.green[500];
    default:
      return '';
  }
};
